import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { DataTaskService } from '@app/core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';

@Component({
    selector: 'tt-po-purch-planning',
    templateUrl: './po-purch-planning.component.html',
    styleUrls: ['./po-purch-planning.component.css'],
    standalone: false,
})
export class PoPurchPlanningComponent implements OnInit {
    public page?: PoPurchPlanningGet;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    public switchingPoToPurchase = false;

    constructor(
        private modal: ModalService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage() {
        this.page = (await this.datatask.Post(2422))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.page) return;

        if (!!this.page.businessco_no) {
            this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.page.businessco_no });
        }
    }

    private loadGrid() {
        if (!this.page) return;

        if (!!this.page.view_id && !!this.page.p2_datatask_keyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.page.view_id)
                    .setLoadDataFunction({
                        method: this.page.p2_datatask_keyno as number,
                        parameters: () => this.page
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'customSave',
                        text: '',
                        tooltip: 'customSave',
                        translateTooltip: true,
                        func: () => this.saveItem(),
                        icon: 'fal fa-save'
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async saveItem() {
        if (!this.page) return;

        try {
            const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({ po_keyno: row['po_keyno'], supplier_no: row['supplier_no'], purchase_quantity: row['purchase_quantity'], deliverydate_wish: row['deliverydate_wish'] }));

            const mergeObj = {
                stockplace_id: this.page.stockplace_id,
            	pos: selectedItems
            }

            const response = (await this.datatask.Post(2424, mergeObj))[0];

            if (response.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            } else {
                this.navigator?.go({ to: 'purchhead', parms: { purch_internal_no: response.purch_internal_no } });

            }
        } finally {
            this.switchingPoToPurchase = false;
        }
    }

    public switchChanges() {
        this.switchingPoToPurchase = true;
        this.saveItem();
    }

    public async onChanged(_: string, id: keyof PoPurchPlanningGet) {
        if (!this.page) return;

        switch (id) {
            case 'businessco_no':
                await this.loadStockPlaces();
                this.loadGrid();
                break;
            case 'stockplace_id':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadPage();
        this.loadCompanies();
        
        Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface PoPurchPlanningGet {
    businessco_no: string;
    stockplace_id: string;
    p2_datatask_keyno: string | number;
    view_id: string;
}
